import { setLabels } from "@shared/helpers/enum-helpers";

export interface SiteSubinventory {
    id: number;
    siteId: string;
    subinventoryType: SubinventoryType;
    name: string;
    isActive: boolean;
}

export enum SubinventoryType {
    ChepPlantPallets = 1,
    ChepComponents = 2,
    TpmProduction = 3,
    ChepPalletStorage = 4,
    WhiteWoodComponents = 5,
    UsedAssetCenter = 6,
    AssetRecovery = 7,
    VendorOnPremise = 8,
    PecoPallets = 9,
    PecoComponents = 10,
    IgpsPallets = 11,
	Rm2Pallets = 12
}

setLabels(SubinventoryType, [
    [SubinventoryType.ChepPlantPallets, 'CHEP Plant'],
    [SubinventoryType.ChepComponents, 'CHEP Components'],
    [SubinventoryType.TpmProduction, 'Wal-Mart TPM'],
    [SubinventoryType.ChepPalletStorage, 'CHEP Storage'],
    [SubinventoryType.WhiteWoodComponents, 'Whitewood Components'],
    [SubinventoryType.UsedAssetCenter, 'Used Asset Center'],
    [SubinventoryType.AssetRecovery, 'Asset Recovery'],
    [SubinventoryType.VendorOnPremise, 'Vendor On Premise'],
    [SubinventoryType.PecoPallets, 'PECO Pallets'],
    [SubinventoryType.PecoComponents, 'PECO Components'],
    [SubinventoryType.IgpsPallets, 'iGPS Pallets'],
    [SubinventoryType.Rm2Pallets, 'RM2 Pallets']
]);
